import { render, staticRenderFns } from "./Textbox.vue?vue&type=template&id=6c9e63e9&"
import script from "./Textbox.vue?vue&type=script&lang=js&"
export * from "./Textbox.vue?vue&type=script&lang=js&"
import style0 from "./Textbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports